import { render, staticRenderFns } from "./articlefilter.vue?vue&type=template&id=778c09be&"
import script from "./articlefilter.vue?vue&type=script&lang=js&"
export * from "./articlefilter.vue?vue&type=script&lang=js&"
import style0 from "./articlefilter.vue?vue&type=style&index=0&id=778c09be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports